import React, { useState } from "react";
import { X } from "react-feather";
import { Modal } from "react-bootstrap";

const DetailModal = ({ selectedDetailModal, setSelectedDetailModal }) => {
  const [detailModalView, setDetailModalView] = useState("market_share");

  const detailedCompetitiveData = {
    "tech-0": {
      name: "Smart Joint Replacement Implants",
      type: "Technology",
      companies: [
        {
          name: "Stryker",
          position: "Leader",
          marketShare: "28%",
          revenue: "~34% of Stryker revenue",
          focus: "Mako-guided knees, Persona IQ telemetry, ASC joint bundles",
          details:
            "Stryker’s sensorized Triathlon and Insignia systems pipe data into ProCare service agreements, giving IDNs proof of faster rehab and locking in implant-plus-robot packages.",
        },
        {
          name: "Johnson & Johnson MedTech",
          position: "Leader",
          marketShare: "25%",
          revenue: "~21% of J&J MedTech revenue",
          focus: "ATTUNE & SIGMA knees, VELYS planning suite, enterprise rebates",
          details:
            "DePuy couples VELYS digital workflow with Ethicon disposables to win exclusive supply deals, but relies on aggressive discounts to combat Stryker’s robotics halo.",
        },
        {
          name: "Zimmer Biomet",
          position: "Leader",
          marketShare: "30%",
          revenue: "~45% of Zimmer revenue",
          focus: "Persona family, ROSA Insight analytics, mymobility remote coaching",
          details:
            "Zimmer Biomet’s Persona IQ smart knee plus ROSA analytics resonates with large joint surgeons; however, ERP-driven fulfilment issues continue to test surgeon patience.",
        },
        {
          name: "Smith & Nephew",
          position: "Growing",
          marketShare: "17%",
          revenue: "~28% of Smith & Nephew revenue",
          focus: "Journey II knees, CORI workflow, value offerings for public tenders",
          details:
            "Smith & Nephew pitches lower-cost implants paired with CORI robotics financing to mid-tier hospitals, trading margin for volume where Stryker and Zimmer are absent.",
        },
      ],
      keyTakeaways:
        "Smart joint implants are a $23.4B market growing 4.8% to 2030; Stryker + Zimmer still control ~58% while DePuy leverages VELYS analytics to stay sticky. This franchise feeds robotics pull-through—**DEFEND AT ALL COSTS** or risk losing the data exhaust that powers service, lending and ASC deals.",
    },
    "tech-1": {
      name: "Surgical Robotics Platforms",
      type: "Technology",
      companies: [
        {
          name: "Stryker",
          position: "Leader",
          marketShare: "46%",
          revenue: "~18% of Stryker revenue",
          focus: "Mako SmartRobotics, Insightful Data services, ASC-capex financing",
          details:
            "Stryker’s 2,500+ installed Mako systems and Insightful analytics make it the default choice for knee/hip ASCs; software updates every six weeks keep procedure time best-in-class.",
        },
        {
          name: "Zimmer Biomet",
          position: "Strong",
          marketShare: "34%",
          revenue: "~14% of Zimmer revenue",
          focus: "ROSA Knee/Hip/Shoulder, ZBEdge AI, joint data subscriptions",
          details:
            "Zimmer ties ROSA adoption to ZBEdge data services and mymobility recovery plans, but still trails Mako in ASC-ready workflow and needs Monogram integration to close the gap.",
        },
        {
          name: "Smith & Nephew",
          position: "Growing",
          marketShare: "20%",
          revenue: "~11% of Smith & Nephew revenue",
          focus: "CORI portable robotics, EVOS trauma alignment, mid-market pricing",
          details:
            "CORI’s portable footprint resonates with mid-tier hospitals and smaller ASCs, yet Smith & Nephew lacks the implant breadth to match Stryker’s cradle-to-grave economics.",
        },
      ],
      keyTakeaways:
        "Robotics is already an $11.1B market compounding 16.5%; OR committees now see robots as mandatory infrastructure. Stryker owns the only scaled ortho-specific platform—**DEFEND AT ALL COSTS** because robotics is the wedge that locks in implants, smart sensors and service revenues for the next decade.",
    },
    "tech-2": {
      name: "Spine Navigation & Fusion Systems",
      type: "Technology",
      companies: [
        {
          name: "Stryker",
          position: "Leader",
          marketShare: "35%",
          revenue: "~12% of Stryker revenue",
          focus: "Q Guidance navigation, Niagara MIS access, Airo CT integration",
          details:
            "Stryker’s Q Guidance plus Niagara access tools give spine surgeons a single vendor for imaging and navigation, helping the company fast-follow Medtronic without owning implants.",
        },
        {
          name: "Johnson & Johnson MedTech",
          position: "Strong",
          marketShare: "33%",
          revenue: "~15% of J&J MedTech revenue",
          focus: "DePuy Synthes spine, VELYS digital, Teligen MIS suite",
          details:
            "J&J leans on the TELIGEN platform and hybrid VELYS data to promise lower radiation doses and faster set-up, but must prove reliability after halting the previous Omniss suite.",
        },
        {
          name: "Zimmer Biomet",
          position: "Strong",
          marketShare: "32%",
          revenue: "~18% of Zimmer revenue",
          focus: "ROSA Spine, Tether scoliosis, comprehensive cages & biologics",
          details:
            "Zimmer Biomet’s ROSA Spine plus vertebral tether portfolio differentiates in deformity cases, yet limited imaging partnerships slow penetration compared with OEM-agnostic rivals.",
        },
      ],
      keyTakeaways:
        "Spine navigation/fusion is an $11.2B segment growing 5.0%; buyers now demand MRI-free workflows and MIS kits. Stryker’s imaging stack lets it sell into Medtronic-heavy sites, while DePuy and Zimmer compete on implant breadth—expect pricing skirmishes in FY26 tender renewals.",
    },
    "tech-3": {
      name: "Neurovascular Intervention Systems",
      type: "Technology",
      companies: [
        {
          name: "Stryker",
          position: "Leader",
          marketShare: "54%",
          revenue: "~9% of Stryker revenue",
          focus: "Trevo NXT, Surpass Evolve, Target coils, 24/7 stroke service",
          details:
            "Stryker’s full toolbox (flow diverter + aspiration + coils) plus on-site stroke navigators gives it unmatched coverage; pipeline of 0.017” devices should hold share in distal stroke.",
        },
        {
          name: "Johnson & Johnson MedTech",
          position: "Strong",
          marketShare: "46%",
          revenue: "~8% of J&J MedTech revenue",
          focus: "CERENOVUS CEREGLIDE access, EMBOTRAP Pro, stroke training labs",
          details:
            "CERENOVUS differentiates with advanced access catheters and real-world data registries, but needs faster launches to counter Stryker’s bundling with hospital capital budgets.",
        },
      ],
      keyTakeaways:
        "Neurovascular tools are a $4.64B market growing 6.5%; only two players own the complete kit—expect procurement battles around comprehensive stroke-center accreditation where service teams, not list price, decide the winner.",
    },
    "tech-4": {
      name: "Sports Medicine & Arthroscopy Platforms",
      type: "Technology",
      companies: [
        {
          name: "Stryker",
          position: "Leader",
          marketShare: "27%",
          revenue: "~13% of Stryker revenue",
          focus: "CinchFix soft-tissue anchors, 1688 AIM imaging, InSpace implant",
          details:
            "Stryker cross-sells 4K visualization with anchors and biologics, and its InSpace implant gives surgeons a differentiated option for irreparable cuff tears.",
        },
        {
          name: "Smith & Nephew",
          position: "Strong",
          marketShare: "25%",
          revenue: "~32% of Smith & Nephew revenue",
          focus: "REGENETEN bioinductive patch, LENS 4K stack, CORIOGRAPH planning",
          details:
            "Smith & Nephew leverages its bioinductive patch to drive consumable pull-through and pairs CORI robotics with soft-tissue kits to win at high-volume sports centers.",
        },
        {
          name: "Arthrex",
          position: "Leader",
          marketShare: "30%",
          revenue: "~70% of Arthrex revenue",
          focus: "Synergy imaging, FiberWire sutures, Nano arthroscopy training",
          details:
            "Arthrex dominates surgeon loyalty via 1,000+ new SKUs yearly and hands-on labs, but its limited capital scale leaves room for Stryker to bundle towers at discount.",
        },
        {
          name: "Johnson & Johnson MedTech",
          position: "Moderate",
          marketShare: "18%",
          revenue: "~6% of J&J MedTech revenue",
          focus: "SutureFix anchors, CONMED alliance, digital rehab pilots",
          details:
            "J&J partners with external sports med specialists and leans on biosurgery adhesives, yet lacks the dedicated sales army of Arthrex to match case coverage.",
        },
      ],
      keyTakeaways:
        "Sports medicine platforms represent a $6.79B market with 6.8% CAGR; Arthrex still sets the pace, but Stryker and Smith & Nephew are using imaging + robotics + biologics bundles to displace niche competitors, especially in integrated sports clinics.",
    },
    "app-0": {
      name: "Joint Replacement Devices",
      type: "Application",
      companies: [
        {
          name: "Stryker",
          position: "Leader",
          marketShare: "29%",
          revenue: "~34% of Stryker revenue",
          focus: "Triathlon knees, Insignia hips, ASC turnkey build-outs",
          details:
            "Stryker’s inventory-light Restock program plus custom trays helps hospitals lower working capital, translating into exclusive supply deals.",
        },
        {
          name: "Johnson & Johnson MedTech",
          position: "Strong",
          marketShare: "24%",
          revenue: "~21% of J&J MedTech revenue",
          focus: "ATTUNE, ACTIS hips, VELYS analytics",
          details:
            "DePuy wins on evidence data packs and blended pricing but struggles with backlog when competing robots aren’t part of the bundle.",
        },
        {
          name: "Zimmer Biomet",
          position: "Leader",
          marketShare: "31%",
          revenue: "~45% of Zimmer revenue",
          focus: "Persona knees, Avenir hips, ROSA synergy",
          details:
            "Zimmer’s mix of implants and ROSA upgrades gives surgeons a familiar workflow, sustaining share despite slower digital deployments.",
        },
        {
          name: "Smith & Nephew",
          position: "Growing",
          marketShare: "16%",
          revenue: "~28% of Smith & Nephew revenue",
          focus: "Journey II knees, Polar3 hips, CORI enablement",
          details:
            "Targets public-sector tenders and differentiated patient-specific instrumentation to chip away at larger incumbents.",
        },
      ],
      keyTakeaways:
        "Joint replacement remains a $23.4B, 4.8% CAGR category—volume is stabilizing but mix is shifting to smart implants and ASC-friendly trays. Stryker and Zimmer are best positioned because they pair implants with robotics and data while others chase rebid-heavy hospital contracts.",
    },
    "app-1": {
      name: "Total Knee Replacement Surgery",
      type: "Application",
      companies: [
        {
          name: "Stryker",
          position: "Leader",
          marketShare: "37%",
          revenue: "~22% of Stryker revenue",
          focus: "Mako-assisted knees, Triathlon cementless, recovery analytics",
          details:
            "Stryker’s cementless knees plus digital rehab modules shorten length of stay, giving it negotiating leverage with value-based care programs.",
        },
        {
          name: "Zimmer Biomet",
          position: "Strong",
          marketShare: "35%",
          revenue: "~30% of Zimmer revenue",
          focus: "Persona IQ, ROSA Knee, mymobility coaching",
          details:
            "Zimmer leans on ROSA + Persona IQ remote monitoring to position itself as the data-rich option for high-acuity centers.",
        },
        {
          name: "Johnson & Johnson MedTech",
          position: "Strong",
          marketShare: "28%",
          revenue: "~18% of J&J MedTech revenue",
          focus: "ATTUNE cementless, VELYS digital surgery, single-tender offers",
          details:
            "J&J bundles knees with orthobiologics to win tenders but still trails in ASC-ready workflows because VELYS robotics volumes lag.",
        },
      ],
      keyTakeaways:
        "Total knees add up to a $12.0B market growing 6.1% through 2030—cementless plus digital rehab is the battlefield. Stryker must **DEFEND AT ALL COSTS** to keep Mako utilization high and prevent Zimmer’s Persona IQ data moat from converting loyalists.",
    },
    "app-2": {
      name: "Spine Surgery Devices",
      type: "Application",
      companies: [
        {
          name: "Stryker",
          position: "Leader",
          marketShare: "33%",
          revenue: "~11% of Stryker revenue",
          focus: "Tritanium cages, Q Guidance, minimally invasive access",
          details:
            "Stryker’s titanium cages plus imaging stack offer a full construct, letting it knock Medtronic out of some hybrid tenders.",
        },
        {
          name: "Johnson & Johnson MedTech",
          position: "Leader",
          marketShare: "34%",
          revenue: "~16% of J&J MedTech revenue",
          focus: "DePuy Synthes UNLEASH platform, Synfix cages, TELIGEN MIS suite",
          details:
            "DePuy balances biologics and smart tools, though it must reassure surgeons after selective implant recalls in Europe.",
        },
        {
          name: "Zimmer Biomet",
          position: "Strong",
          marketShare: "33%",
          revenue: "~20% of Zimmer revenue",
          focus: "ROSA Spine, Tether scoliosis, comprehensive cages",
          details:
            "Zimmer captures premium deformity work with tethering but still works to align ROSA Spine instrumentation lead times with OR scheduling.",
        },
      ],
      keyTakeaways:
        "Spine hardware is an $11.2B market growing 5.0%; minimally invasive deformity correction is the whitespace. Expect more cross-licensing of biologics as hospitals push for single invoices that cover cages, screws and navigation.",
    },
    "app-3": {
      name: "Trauma Fixation Systems",
      type: "Application",
      companies: [
        {
          name: "Stryker",
          position: "Leader",
          marketShare: "32%",
          revenue: "~10% of Stryker revenue",
          focus: "Gamma4 nails, AxSOS plates, emergent consignment services",
          details:
            "Stryker’s 24/7 field inventory hubs allow immediate restock, winning loyalty from trauma networks that cannot tolerate stock-outs.",
        },
        {
          name: "Johnson & Johnson MedTech",
          position: "Strong",
          marketShare: "30%",
          revenue: "~12% of J&J MedTech revenue",
          focus: "Synthes VA-LCP, DYNANITE nails, military contracts",
          details:
            "DePuy drives volume via global trauma tenders and training programs, but rising raw-material costs pressure margins.",
        },
        {
          name: "Zimmer Biomet",
          position: "Strong",
          marketShare: "25%",
          revenue: "~14% of Zimmer revenue",
          focus: "A.L.P.S. plates, ClearMix cement, revision kits",
          details:
            "Zimmer plays in high-acuity trauma centers with advanced plating but needs faster instrument sterilization cycles to compete fully.",
        },
        {
          name: "Smith & Nephew",
          position: "Moderate",
          marketShare: "13%",
          revenue: "~9% of Smith & Nephew revenue",
          focus: "EVOS trauma, fast-track supply, combined wound portfolio",
          details:
            "Smith & Nephew cross-promotes wound care with trauma hardware, giving it a foothold in burn/ortho hybrid wards.",
        },
      ],
      keyTakeaways:
        "Trauma fixation is a $5.0B market growing 8.3% through 2025; service and consignment matter more than implant design. Stryker and DePuy are battling to own Level I call coverage while Zimmer pushes personalized revision kits.",
    },
    "app-4": {
      name: "Sports Medicine & Soft-Tissue Repair",
      type: "Application",
      companies: [
        {
          name: "Stryker",
          position: "Leader",
          marketShare: "28%",
          revenue: "~13% of Stryker revenue",
          focus: "CinchFix, PEEK anchors, biologic augmentation",
          details:
            "Combining high-definition visualization with new biomaterials lets Stryker promise fewer revisions at outpatient centers.",
        },
        {
          name: "Smith & Nephew",
          position: "Strong",
          marketShare: "24%",
          revenue: "~33% of Smith & Nephew revenue",
          focus: "REGENETEN patch, COBLATION, CORI access",
          details:
            "Smith & Nephew’s regenerative patch extends into complex cuff repairs and raises average selling price despite pricing pressure.",
        },
        {
          name: "Arthrex",
          position: "Leader",
          marketShare: "34%",
          revenue: "~70% of Arthrex revenue",
          focus: "FiberWire, SwiveLock, surgeon education labs",
          details:
            "Arthrex’s education-first model keeps surgeons loyal, but limited ability to finance capital gear leaves holes for competitors.",
        },
        {
          name: "Johnson & Johnson MedTech",
          position: "Moderate",
          marketShare: "14%",
          revenue: "~6% of J&J MedTech revenue",
          focus: "Biosurgery adhesives, Ortho solutions partnerships",
          details:
            "J&J integrates Ethicon closure solutions with DePuy implants for comprehensive soft-tissue programs, though share remains modest.",
        },
      ],
      keyTakeaways:
        "Soft-tissue repair equals a $6.79B market (6.8% CAGR) but is shifting outpatient. Players that pair biologics with towers—and train allied staff—win the referral stream.",
    },
    "app-5": {
      name: "Neurovascular Stroke Intervention",
      type: "Application",
      companies: [
        {
          name: "Stryker",
          position: "Leader",
          marketShare: "55%",
          revenue: "~9% of Stryker revenue",
          focus: "Flow diversion + aspiration kits, stroke center partnerships",
          details:
            "Stryker’s one-hour response teams and turnkey center-of-excellence playbooks keep it embedded with stroke directors.",
        },
        {
          name: "Johnson & Johnson MedTech",
          position: "Strong",
          marketShare: "45%",
          revenue: "~8% of J&J MedTech revenue",
          focus: "CERENOVUS stroke solutions, white-space geographies",
          details:
            "CERENOVUS uses simulation labs and integrated training to win new thrombectomy centers in Latin America and India.",
        },
      ],
      keyTakeaways:
        "Neurovascular stroke care is a $3.6B category expanding 8.7%; accreditation drive means whoever provides education and uptime guarantees wins recurring coil and aspiration spend.",
    },
    "geo-0": {
      name: "North America Biomaterials Demand",
      type: "Geography",
      companies: [
        {
          name: "Stryker",
          position: "Leader",
          marketShare: "31%",
          revenue: "~65% of Stryker revenue",
          focus: "ASC partnerships, U.S. federal accounts, 45-plant supply chain",
          details:
            "Stryker’s U.S. manufacturing footprint plus direct ASC build teams allow it to promise 2-week install timelines, a differentiator versus EU-centric rivals.",
        },
        {
          name: "Johnson & Johnson MedTech",
          position: "Leader",
          marketShare: "27%",
          revenue: "~55% of J&J MedTech revenue",
          focus: "Enterprise IDN deals, bundling Ethicon/DePuy, innovation centers",
          details:
            "J&J leverages 57-country distribution but still battles to keep ortho share as IDNs demand robotics parity with Stryker.",
        },
        {
          name: "Zimmer Biomet",
          position: "Strong",
          marketShare: "24%",
          revenue: "~54% of Zimmer revenue",
          focus: "ROSA acceleration, U.S. VA contracts, digital care",
          details:
            "Zimmer invests heavily in U.S. digital therapeutics to offset slower Europe demand, but culture change is ongoing after ERP turbulence.",
        },
        {
          name: "Smith & Nephew",
          position: "Moderate",
          marketShare: "18%",
          revenue: "~33% of Smith & Nephew revenue",
          focus: "Sports med dominance, wound plus ortho bundles, CORI installs",
          details:
            "Smith & Nephew gains share where hospital systems want integrated sports + wound programs, though U.S. logistics remain lean.",
        },
      ],
      keyTakeaways:
        "North America biomaterials equal ~$18.2B (40.2% of the $45.2B global market) and grow 7.3% annually. Buyers now judge OEMs on U.S. service density and ability to retrofit robotics into legacy ORs—Stryker’s domestic footprint remains the benchmark.",
    },
    "geo-1": {
      name: "Europe Biomaterials Demand",
      type: "Geography",
      companies: [
        {
          name: "Johnson & Johnson MedTech",
          position: "Leader",
          marketShare: "28%",
          revenue: "~22% of J&J MedTech revenue",
          focus: "DePuy Synthes EMEA, CERENOVUS scaling, value-based tenders",
          details:
            "J&J leverages Horizon Europe-funded sites to pilot digital knees but must contend with strict price ceilings in DACH markets.",
        },
        {
          name: "Zimmer Biomet",
          position: "Leader",
          marketShare: "26%",
          revenue: "~27% of Zimmer revenue",
          focus: "EMEA ROSA hubs, personalized implants, local manufacturing",
          details:
            "Zimmer’s Swiss and Polish plants shorten lead times, letting it address EU tender penalties around delivery lapses.",
        },
        {
          name: "Stryker",
          position: "Strong",
          marketShare: "24%",
          revenue: "~20% of Stryker revenue",
          focus: "Trauma + neurovascular combos, UK/Ireland ASC pilots",
          details:
            "Stryker mixes neurovascular and ortho bids to win NHS frameworks, but still invests in EU-based finishing to avoid tariffs.",
        },
        {
          name: "Smith & Nephew",
          position: "Strong",
          marketShare: "22%",
          revenue: "~41% of Smith & Nephew revenue",
          focus: "UK home market, CORI expansion, wound synergy",
          details:
            "Smith & Nephew’s HQ proximity keeps it close to NICE committees, enabling faster guideline inclusion for new implants.",
        },
      ],
      keyTakeaways:
        "Europe represents ~$14.2B of biomaterials demand with a similar 7.3% CAGR but heavier tender oversight. OEMs win when they combine local finishing, MDR-ready documentation and training packages that alleviate staffing shortages.",
    },
    "geo-2": {
      name: "Asia Pacific Biomaterials Demand",
      type: "Geography",
      companies: [
        {
          name: "Stryker",
          position: "Leader",
          marketShare: "33%",
          revenue: "~35% of Stryker APAC revenue",
          focus: "China joint ventures, India price management, neurovascular",
          details:
            "Stryker localizes more trauma and neurovascular production in China to hit volume-based procurement price caps while protecting premium robotics.",
        },
        {
          name: "Johnson & Johnson MedTech",
          position: "Strong",
          marketShare: "30%",
          revenue: "~28% of J&J MedTech APAC revenue",
          focus: "CERENOVUS Japan, DePuy India arthroplasty, VELYS training hubs",
          details:
            "J&J leverages broad regulatory relationships but still works to trim lead times that hamper penetration in Southeast Asia.",
        },
        {
          name: "Zimmer Biomet",
          position: "Moderate",
          marketShare: "25%",
          revenue: "~23% of Zimmer APAC revenue",
          focus: "Persona partial knees, ROSA alliances, India manufacturing",
          details:
            "Zimmer competes on patient-specific implants and invests in India production to meet Make-in-India mandates.",
        },
      ],
      keyTakeaways:
        "APAC biomaterials total ~$9.7B today yet expand fastest at 7.7% CAGR; localization plus stroke-center investments dictate winners. Stryker’s joint ventures give it a head start, but price caps demand relentless cost engineering.",
    },
    "geo-3": {
      name: "LatAm & MEA Biomaterials Demand",
      type: "Geography",
      companies: [
        {
          name: "Stryker",
          position: "Leader",
          marketShare: "55%",
          revenue: "~6% of Stryker revenue",
          focus: "Brazil trauma, Gulf neurovascular, distributor enablement",
          details:
            "Stryker pairs distributor training with capital-light robotics leases to offset currency swings in Brazil and the Gulf.",
        },
        {
          name: "Johnson & Johnson MedTech",
          position: "Strong",
          marketShare: "45%",
          revenue: "~7% of J&J MedTech revenue",
          focus: "CERENOVUS growth markets, DePuy tenders, tiered pricing",
          details:
            "J&J leans on long-standing government relationships to secure trauma and neurovascular tenders, though service coverage varies widely.",
        },
      ],
      keyTakeaways:
        "LatAm & MEA account for roughly $3.1B (6.9% of global biomaterials) yet grow at 7.3% with high volatility. Success hinges on financing options and training programs that compensate for uneven specialist density—both Stryker and J&J rely on hybrid distributor models here.",
    },
    "seg-0": {
      name: "Hospitals & IDNs",
      type: "Customer Segment",
      companies: [
        {
          name: "Stryker",
          position: "Leader",
          marketShare: "30%",
          revenue: "~48% of Stryker revenue",
          focus: "OR integration, robotics fleets, risk-sharing service",
          details:
            "Stryker’s turnkey OR modernization model (capital + service + analytics) underpins multi-year contracts with IDNs chasing throughput guarantees.",
        },
        {
          name: "Johnson & Johnson MedTech",
          position: "Strong",
          marketShare: "28%",
          revenue: "~40% of J&J MedTech revenue",
          focus: "Enterprise perioperative bundles, VELYS + Ethicon, data rebates",
          details:
            "J&J offers cross-portfolio rebates to retain share, leveraging Ethicon consumables as bargaining chips for orthopedic loyalty.",
        },
        {
          name: "Zimmer Biomet",
          position: "Moderate",
          marketShare: "22%",
          revenue: "~38% of Zimmer revenue",
          focus: "ZBEdge insights, ROSA fleet renewals, digital rehab",
          details:
            "Zimmer positions ZBEdge analytics as a hospital KPI dashboard, though integration resources limit how fast it can scale.",
        },
        {
          name: "Smith & Nephew",
          position: "Moderate",
          marketShare: "20%",
          revenue: "~35% of Smith & Nephew revenue",
          focus: "CORI surgical program, wound-ortho cross-selling, MDR compliance",
          details:
            "Smith & Nephew bundles wound care with ortho to win theatre access, especially in EU public systems seeking fewer vendors.",
        },
      ],
      keyTakeaways:
        "Hospital IDNs spend ~$2.1B on OR integration today (12.1% CAGR). They want vendors to guarantee uptime and staffing support—Stryker’s digital service bench is the reference point.",
    },
    "seg-1": {
      name: "Ambulatory Surgery Centers",
      type: "Customer Segment",
      companies: [
        {
          name: "Stryker",
          position: "Leader",
          marketShare: "42%",
          revenue: "~20% of Stryker revenue",
          focus: "ASC playbooks, Mako Flex financing, turnkey supply chain",
          details:
            "Stryker builds ASCs end-to-end, offering modular capital leases and supplying case carts that minimize onsite sterile processing.",
        },
        {
          name: "Zimmer Biomet",
          position: "Strong",
          marketShare: "28%",
          revenue: "~18% of Zimmer revenue",
          focus: "ROSA Outpatient programs, mymobility monitoring, lightweight trays",
          details:
            "Zimmer’s ASC program stresses smaller instrument sets and remote therapy for bundled payments but lags Stryker in service depth.",
        },
        {
          name: "Smith & Nephew",
          position: "Growing",
          marketShare: "20%",
          revenue: "~15% of Smith & Nephew revenue",
          focus: "CORI portability, REGENETEN procedures, mid-market pricing",
          details:
            "Smith & Nephew wins physicians who want portable robotics for leased space, though capital constraints cap speed.",
        },
        {
          name: "Arthrex",
          position: "Moderate",
          marketShare: "10%",
          revenue: "~65% of Arthrex revenue",
          focus: "Synergy imaging, sports med kits, surgeon-owned ASC alliances",
          details:
            "Arthrex dominates sports-focused ASCs via education-first support yet lacks financing scale for multi-specialty centers.",
        },
      ],
      keyTakeaways:
        "ASC enablement leans on the same $11.1B robotics market (16.5% CAGR) but values smaller footprints and rapid payback—Stryker’s ability to underwrite build-outs keeps surgeons loyal as outpatient knees surge.",
    },
    "seg-2": {
      name: "Orthopedic & Sports Clinics",
      type: "Customer Segment",
      companies: [
        {
          name: "Arthrex",
          position: "Leader",
          marketShare: "40%",
          revenue: "~70% of Arthrex revenue",
          focus: "Surgeon education, Synergy towers, biologics",
          details:
            "Arthrex’s peer-to-peer labs and rapid product refreshes make it the default at specialist clinics despite limited robotics.",
        },
        {
          name: "Stryker",
          position: "Strong",
          marketShare: "32%",
          revenue: "~12% of Stryker revenue",
          focus: "1688 AIM imaging, sports med disposables, Rejuve biologics",
          details:
            "Stryker bundles imaging, shavers and biologics to win health-system owned sports clinics seeking a single vendor.",
        },
        {
          name: "Smith & Nephew",
          position: "Strong",
          marketShare: "28%",
          revenue: "~30% of Smith & Nephew revenue",
          focus: "REGENETEN, COBLATION, CORI portable robotics",
          details:
            "Smith & Nephew offers CORI plus biologics for partial knees in office-based labs, carving out share where MIL tends toward low capital.",
        },
      ],
      keyTakeaways:
        "Orthopedic/sports clinics consume $6.79B of product and grow 6.8%; educational support and capital-light bundles decide winners—Arthrex leads on loyalty while Stryker adds robotics to edge into private practice alliances.",
    },
    "seg-3": {
      name: "Neurovascular Stroke Centers",
      type: "Customer Segment",
      companies: [
        {
          name: "Stryker",
          position: "Leader",
          marketShare: "56%",
          revenue: "~9% of Stryker revenue",
          focus: "Stroke excellence programs, Trevo & Surpass kits, 24/7 field teams",
          details:
            "Stryker’s guaranteed response times plus comprehensive training keep it embedded as centers pursue Joint Commission certification.",
        },
        {
          name: "Johnson & Johnson MedTech",
          position: "Strong",
          marketShare: "44%",
          revenue: "~8% of J&J MedTech revenue",
          focus: "CEREGLIDE access, EMBOTRAP Pro, CERENOVUS stroke readiness labs",
          details:
            "J&J invests in simulation labs to help hospitals staff call schedules, closing the gap where Stryker previously had incumbency.",
        },
      ],
      keyTakeaways:
        "Stroke centers mirror the $4.64B neurovascular market growing 6.5%; service SLAs and training capacity trump sticker price, explaining why only two OEMs meaningfully compete.",
    },
    "seg-4": {
      name: "Trauma Networks & Level I Centers",
      type: "Customer Segment",
      companies: [
        {
          name: "Stryker",
          position: "Leader",
          marketShare: "33%",
          revenue: "~11% of Stryker revenue",
          focus: "Gamma nails, 24/7 consignment, integrated neuro access",
          details:
            "Stryker’s field consignment plus neurovascular add-ons let it capture more wallet share per trauma activation.",
        },
        {
          name: "Johnson & Johnson MedTech",
          position: "Strong",
          marketShare: "29%",
          revenue: "~13% of J&J MedTech revenue",
          focus: "Synthes trauma, military-grade supply, cross-training",
          details:
            "DePuy Synthes remains the reference for comprehensive trauma sets, but lead times are increasingly scrutinized.",
        },
        {
          name: "Zimmer Biomet",
          position: "Strong",
          marketShare: "24%",
          revenue: "~15% of Zimmer revenue",
          focus: "A.L.P.S. plating, ClearMix cement, revision expertise",
          details:
            "Zimmer targets complex revisions and oncology-related trauma with bespoke planning support.",
        },
        {
          name: "Smith & Nephew",
          position: "Moderate",
          marketShare: "14%",
          revenue: "~10% of Smith & Nephew revenue",
          focus: "EVOS plates, wound care combos, cost-effective kits",
          details:
            "Smith & Nephew combines negative-pressure wound therapy with trauma hardware to win bundle-focused hospitals.",
        },
      ],
      keyTakeaways:
        "Trauma networks spend $5.0B on hardware (+8.3% CAGR) and prize inventory availability; Stryker and DePuy continue to close multi-year exclusive contracts tied to consignment performance.",
    },
    "custseg-0": {
      name: "Large Joint Reconstruction",
      type: "Customer Segment",
      companies: [
        {
          name: "Stryker",
          position: "Leader",
          marketShare: "29%",
          revenue: "~34% of Stryker revenue",
          focus: "Triathlon knees, Insignia hips, Mako training",
          details:
            "Tight integration between implants and robotics ensures every high-volume surgeon gets targeted coaching and upgrades.",
        },
        {
          name: "Johnson & Johnson MedTech",
          position: "Strong",
          marketShare: "24%",
          revenue: "~21% of J&J MedTech revenue",
          focus: "ATTUNE, ACTIS, VELYS analytics",
          details:
            "DePuy combines patient-specific planning with global reference sites to keep multi-hospital systems loyal.",
        },
        {
          name: "Zimmer Biomet",
          position: "Leader",
          marketShare: "31%",
          revenue: "~45% of Zimmer revenue",
          focus: "Persona knee ecosystem, ROSA tie-ins, mymobility app",
          details:
            "Zimmer’s remote monitoring offers payer-friendly data, softening the blow from recent ERP disruptions.",
        },
        {
          name: "Smith & Nephew",
          position: "Growing",
          marketShare: "16%",
          revenue: "~28% of Smith & Nephew revenue",
          focus: "Journey II knees, Polar3 hips, CORI enablement",
          details:
            "Focuses on mid-volume hospitals needing flexible capital options and surgeon-friendly instrumentation.",
        },
      ],
      keyTakeaways:
        "Large-joint customers represent the same $23.4B market with 4.8% CAGR; they demand robotics plus data-literate reps. Stryker must protect every Mako-enabled account to prevent Zimmer or DePuy from swapping trays during rebids.",
    },
    "custseg-1": {
      name: "Robotic & Navigation Surgery Platforms",
      type: "Customer Segment",
      companies: [
        {
          name: "Stryker",
          position: "Leader",
          marketShare: "46%",
          revenue: "~18% of Stryker revenue",
          focus: "Mako fleets, Insightful analytics, ASC-ready service",
          details:
            "Offers outcome-based pricing and uptime guarantees, making it easier for administrators to approve repeat purchases.",
        },
        {
          name: "Zimmer Biomet",
          position: "Strong",
          marketShare: "28%",
          revenue: "~14% of Zimmer revenue",
          focus: "ROSA portfolio, ZBEdge dashboards, financing partnerships",
          details:
            "Zimmer fuels adoption with data subscriptions that benchmark surgeons versus peers, aiding change management.",
        },
        {
          name: "Johnson & Johnson MedTech",
          position: "Growing",
          marketShare: "16%",
          revenue: "~7% of J&J MedTech revenue",
          focus: "VELYS Digital Surgery, Omniss ecosystem reboot",
          details:
            "VELYS installs are ramping, but J&J must demonstrate reliability at ASC pace to catch up.",
        },
        {
          name: "Smith & Nephew",
          position: "Moderate",
          marketShare: "10%",
          revenue: "~6% of Smith & Nephew revenue",
          focus: "CORI portability, surgeon-owned centers, low-capex offers",
          details:
            "CORI’s compact size earns wins in mixed-specialty centers even without a huge capital budget.",
        },
      ],
      keyTakeaways:
        "Robotic customers track the $11.1B market at 16.5% CAGR; procurement is shifting to multi-site fleet renewals. This is Stryker’s most defensible wedge—**DEFEND AT ALL COSTS** by keeping Insightful analytics ahead of ROSA and VELYS.",
    },
    "custseg-2": {
      name: "Sports Medicine & Arthroscopy",
      type: "Customer Segment",
      companies: [
        {
          name: "Arthrex",
          position: "Leader",
          marketShare: "34%",
          revenue: "~70% of Arthrex revenue",
          focus: "Nano arthroscopy, Synergy towers, surgeon education",
          details:
            "Owns training relationships that feed direct-to-clinic demand, though lacks financing muscle for large systems.",
        },
        {
          name: "Stryker",
          position: "Leader",
          marketShare: "28%",
          revenue: "~13% of Stryker revenue",
          focus: "1688 AIM tower, Rejuve biologics, ambulatory workflow",
          details:
            "Stryker couples imaging with implants and can promise 90-day implementation inside ASC networks.",
        },
        {
          name: "Smith & Nephew",
          position: "Strong",
          marketShare: "24%",
          revenue: "~30% of Smith & Nephew revenue",
          focus: "REGENETEN, COBLATION, portable robotics",
          details:
            "Wins with biologic patch outcomes and fast case turnover support for clinic-based surgeons.",
        },
        {
          name: "Zimmer Biomet",
          position: "Moderate",
          marketShare: "14%",
          revenue: "~8% of Zimmer revenue",
          focus: "Sports medicine biologics, ROSA compatibility",
          details:
            "Zimmer leverages ROSA relationships to upsell sports med disposables, though portfolio depth trails rivals.",
        },
      ],
      keyTakeaways:
        "Sports-focused customers mirror the $6.79B market (6.8% CAGR); clinics back vendors that blend biologics, visualization and education. Arthrex still leads loyalty, but Stryker is catching up via turnkey ASC solutions.",
    },
    "custseg-3": {
      name: "Neurovascular Stroke Intervention",
      type: "Customer Segment",
      companies: [
        {
          name: "Stryker",
          position: "Leader",
          marketShare: "55%",
          revenue: "~9% of Stryker revenue",
          focus: "Trevo + Surpass kits, stroke navigator teams, analytics",
          details:
            "Guarantees 1-hour response and maintains on-site inventory, helping hospitals meet door-to-recanalization targets.",
        },
        {
          name: "Johnson & Johnson MedTech",
          position: "Strong",
          marketShare: "45%",
          revenue: "~8% of J&J MedTech revenue",
          focus: "CERENOVUS platform, simulation labs, emerging-market focus",
          details:
            "Uses simulation labs to train staff and secure reimbursement readiness, especially in newer thrombectomy markets.",
        },
      ],
      keyTakeaways:
        "Stroke customers align with the $4.64B neurovascular segment (6.5% growth); coverage models and education capacity dictate share more than catalog breadth.",
    },
    "custseg-4": {
      name: "ASC Digital Enablement",
      type: "Customer Segment",
      companies: [
        {
          name: "Stryker",
          position: "Leader",
          marketShare: "38%",
          revenue: "~20% of Stryker revenue",
          focus: "ProCare remote monitoring, OR integration, logistics-as-a-service",
          details:
            "Stryker’s Insightful dashboards plus logistics outsourcing let ASCs run lean staff without sacrificing case volume.",
        },
        {
          name: "Johnson & Johnson MedTech",
          position: "Strong",
          marketShare: "33%",
          revenue: "~15% of J&J MedTech revenue",
          focus: "VELYS digital tools, Ethicon energy, ASC design consulting",
          details:
            "J&J bundles Ethicon energy and digital surgery support to get a seat at the ASC planning table, though robotics gaps remain.",
        },
        {
          name: "Smith & Nephew",
          position: "Growing",
          marketShare: "29%",
          revenue: "~18% of Smith & Nephew revenue",
          focus: "CORI portability, REGENETEN pathways, low maintenance towers",
          details:
            "Smith & Nephew promotes low-maintenance towers and biologic protocols that appeal to lean ASC staffing models.",
        },
      ],
      keyTakeaways:
        "ASC digital infrastructure ties to the $2.1B OR integration market growing 12.1%; whoever supplies analytics + service desks will win the next wave of multi-site outpatient deals.",
    },
  };

  const marketData = {
    "tech-0": {
      size: "$23.4B",
      year: "2024",
      cagr: "4.8%",
      period: "2024-2030",
    },
    "tech-1": {
      size: "$11.1B",
      year: "2024",
      cagr: "16.5%",
      period: "2024-2029",
    },
    "tech-2": {
      size: "$11.2B",
      year: "2023",
      cagr: "5.0%",
      period: "2023-2028",
    },
    "tech-3": {
      size: "$4.64B",
      year: "2025",
      cagr: "6.5%",
      period: "2025-2030",
    },
    "tech-4": {
      size: "$6.79B",
      year: "2024",
      cagr: "6.8%",
      period: "2024-2029",
    },
    "app-0": {
      size: "$23.4B",
      year: "2024",
      cagr: "4.8%",
      period: "2024-2030",
    },
    "app-1": {
      size: "$12.0B",
      year: "2025",
      cagr: "6.1%",
      period: "2025-2030",
    },
    "app-2": {
      size: "$11.2B",
      year: "2023",
      cagr: "5.0%",
      period: "2023-2028",
    },
    "app-3": {
      size: "$5.0B",
      year: "2020",
      cagr: "8.3%",
      period: "2020-2025",
    },
    "app-4": {
      size: "$6.79B",
      year: "2024",
      cagr: "6.8%",
      period: "2024-2029",
    },
    "app-5": {
      size: "$3.6B",
      year: "2023",
      cagr: "8.7%",
      period: "2023-2028",
    },
    "geo-0": {
      size: "$18.2B",
      year: "2024",
      cagr: "7.3%",
      period: "2024-2029",
    },
    "geo-1": {
      size: "$14.2B",
      year: "2024",
      cagr: "7.3%",
      period: "2024-2029",
    },
    "geo-2": {
      size: "$9.7B",
      year: "2024",
      cagr: "7.7%",
      period: "2024-2029",
    },
    "geo-3": {
      size: "$3.1B",
      year: "2024",
      cagr: "7.3%",
      period: "2024-2029",
    },
    "seg-0": {
      size: "$2.1B",
      year: "2023",
      cagr: "12.1%",
      period: "2023-2028",
    },
    "seg-1": {
      size: "$11.1B",
      year: "2024",
      cagr: "16.5%",
      period: "2024-2029",
    },
    "seg-2": {
      size: "$6.79B",
      year: "2024",
      cagr: "6.8%",
      period: "2024-2029",
    },
    "seg-3": {
      size: "$4.64B",
      year: "2025",
      cagr: "6.5%",
      period: "2025-2030",
    },
    "seg-4": {
      size: "$5.0B",
      year: "2020",
      cagr: "8.3%",
      period: "2020-2025",
    },
    "custseg-0": {
      size: "$23.4B",
      year: "2024",
      cagr: "4.8%",
      period: "2024-2030",
    },
    "custseg-1": {
      size: "$11.1B",
      year: "2024",
      cagr: "16.5%",
      period: "2024-2029",
    },
    "custseg-2": {
      size: "$6.79B",
      year: "2024",
      cagr: "6.8%",
      period: "2024-2029",
    },
    "custseg-3": {
      size: "$4.64B",
      year: "2025",
      cagr: "6.5%",
      period: "2025-2030",
    },
    "custseg-4": {
      size: "$2.1B",
      year: "2023",
      cagr: "12.1%",
      period: "2023-2028",
    },
  };

  const renderPositionDots = (position, companyName) => {
    const dotsCount =
      position === "Leader" || position === "Dominant"
        ? 5
        : position === "Strong"
        ? 4
        : position === "Growing" || position === "Moderate"
        ? 3
        : position === "Limited"
        ? 2
        : position === "None"
        ? 0
        : 1;

    const companyColors = {
      Henkel: "danger",
      "H.B. Fuller": "primary",
      Bostik: "info",
      Tailored: "secondary",
      Stryker: "success",
      "Johnson & Johnson MedTech": "danger",
      "Zimmer Biomet": "primary",
      "Smith & Nephew": "info",
      Arthrex: "warning",
    };

    const color = companyColors[companyName] || "secondary";

    return (
      <div
        className="d-flex gap-1 align-items-center"
        title={`${companyName}: ${position}`}
      >
        {[...Array(5)].map((_, idx) => (
          <div
            key={idx}
            className={`rounded-circle ${
              idx < dotsCount
                ? `bg-${color}`
                : "bg-light border border-2 border-secondary"
            }`}
            style={{ width: "12px", height: "12px" }}
          ></div>
        ))}
      </div>
    );
  };

  if (!selectedDetailModal) return null;

  const modalData = detailedCompetitiveData[selectedDetailModal];
  if (!modalData) return null;

  return (
    <Modal
      show={!!selectedDetailModal}
      onHide={() => setSelectedDetailModal(null)}
      size="xl"
      centered
      scrollable
    >
      <style>{`
        .modal-header-gradient {
          font-weight: 600;
          font-size: 14px;
          line-height: 17.5px;
          color: #1e1c25;
          margin-bottom: 3px;
        }
        .market-info-bar {
          background: #f7f9ff;
          padding: 1.5rem;
          border-bottom: 2px solid #d0deff;
        }
        .market-stat {
          padding: 12px;
          background: white;
          border-radius: 8px;
          font-size:14px;
          border-left: 4px solid #6610f2;
        }
        .tab-button {
          padding: 12px 16px;
          border-radius: 0.5rem;
          font-weight: 500;
          font-size: 13px;
          transition: all 0.3s;
          border: none;
          cursor: pointer;
        }
        .tab-button-active {
          background: #4E6BCA;
          color: #fff;
          font-weight: 500;
          box-shadow: 0 2px 8px rgba(102,16,242,0.4);
        }
        .tab-button-inactive {
          background: #fff;
          color: #6c757d;
          border: 1px solid #dee2e6;
        }
        .tab-button-inactive:hover {
          background: #fff;
          border-color: #6610f2;
        }
        .company-row-bostik {
          background: #d1ecf1 !important;
        }
        .company-row-henkel {
          background: #f8d7da !important;
        }
        .company-row-hbfuller {
          background: #cfe2ff !important;
        }
        .company-row-tailored {
          background: #e2e3e5 !important;
        }
        .company-row td {
          padding: 12px;
          position: relative;
          border-bottom: 1px solid #e2e8f0;
          border-right: 1px solid #e2e8f0;
          white-space: normal;
          overflow: hidden;
          word-break: break-word;
          vertical-align: middle;
          font-weight: unset;
          font-size: 12px;
        }
        .takeaway-box {
          background: linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%);
          border-left: 5px solid #ffa726;
          border-radius: 8px;
          padding: 12px 16px;
        }
        .modal-content {
          border: none;
          border-radius: 1rem;
          overflow: hidden;
        }
        .close-button {
          background: #fff;
          border: none;
          border-radius: 0.375rem;
          padding: 0.5rem;
          width: 2.5rem;
          height: 2.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s;
        }
        .close-button:hover {
          background: #f8f9fa;
          transform: scale(1.1);
        }
        .modal-title-new{
          font-size: 16px;
          font-weight: 600 !important;
        }
      `}</style>

      <Modal.Header className="modal-header-gradient border-0">
        <div className="d-flex justify-content-between alignments-start w-100">
          <div>
            <div className="text-sm opacity-90 mb-1">
              {modalData.type} Deep Dive
            </div>
            <Modal.Title className="text-2xl font-bold text-white modal-title-new d-inline">
              <span className="modal-title-new">{modalData.name}</span>
              <a
                href="https://www.marketsandmarkets.com/knowledgestore.asp"
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 py-2 bg-blue-600 text-sm font-semibold rounded-lg hover:bg-blue-700 transition flex items-center gap-2"
              >
                <span>📊</span>View Market Report
              </a>
            </Modal.Title>
          </div>
          <button
            onClick={() => setSelectedDetailModal(null)}
            className="close-button"
          >
            <X size={20} color="#6610f2" />
          </button>
        </div>
      </Modal.Header>

      {marketData[selectedDetailModal] && (
        <div className="market-info-bar">
          <div className="row g-3">
            <div className="col-md-6">
              <div className="market-stat">
                <div
                  className="small text-uppercase mb-2"
                  style={{ color: "#6610f2", letterSpacing: "0.5px" }}
                >
                  MARKET SIZE
                </div>
                <div
                  className="h2 fw-bold mb-1"
                  style={{ color: "#1e293b", fontSize: "16px" }}
                >
                  {marketData[selectedDetailModal].size}
                </div>
                <div className="small text-muted">
                  Global ({marketData[selectedDetailModal].year})
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="market-stat">
                <div
                  className="small text-uppercase mb-2"
                  style={{ color: "#6610f2", letterSpacing: "0.5px" }}
                >
                  GROWTH RATE
                </div>
                <div
                  className="h2 fw-bold mb-1 text-success"
                  style={{ fontSize: "16px" }}
                >
                  {marketData[selectedDetailModal].cagr}
                </div>
                <div className="small text-muted">
                  CAGR {marketData[selectedDetailModal].period}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="bg-light p-3">
        <div className="d-flex gap-2">
          {[
            { id: "market_share", label: "Market Position" },
            { id: "revenue", label: "Revenue Contribution" },
            {
              id: "focus",
              label:
                modalData.type === "Customer Segment"
                  ? "Key Pain Points"
                  : "Company Focus",
            },
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => setDetailModalView(tab.id)}
              className={`tab-button ${
                detailModalView === tab.id
                  ? "tab-button-active"
                  : "tab-button-inactive"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <Modal.Body className="p-0">
        <div className="table-responsive">
          <table className="custom-resizable-table p-3">
            <thead
              style={{
                background: "#f8f9fa",
                borderBottom: "2px solid #dee2e6",
              }}
            >
              <tr className="custom-resizable-table-header">
                <th className="fw-bold py-3 px-4" style={{ width: "15%" }}>
                  <div className="custom-resizable-table-th-content">
                    Company
                  </div>
                </th>
                <th className="fw-bold py-3 px-4" style={{ width: "20%" }}>
                  <div className="custom-resizable-table-th-content">
                    {" "}
                    Market Position
                  </div>
                </th>
                {detailModalView === "market_share" && (
                  <th className="fw-bold py-3 px-4" style={{ width: "15%" }}>
                    <div className="custom-resizable-table-th-content">
                      Market Share
                    </div>
                  </th>
                )}
                {detailModalView === "revenue" && (
                  <th className="fw-bold py-3 px-4" style={{ width: "20%" }}>
                    <div className="custom-resizable-table-th-content">
                      {" "}
                      Revenue Contribution
                    </div>
                  </th>
                )}
                {detailModalView === "focus" && (
                  <th className="fw-bold py-3 px-4" style={{ width: "25%" }}>
                    {modalData.type === "Customer Segment"
                      ? "Key Pain Points"
                      : "Strategic Focus"}
                  </th>
                )}
                <th className="fw-bold py-3 px-4">
                  <div className="custom-resizable-table-th-content">
                    Key Details
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {modalData.companies.map((company, idx) => {
                const companyRowClass =
                  company.name === "Henkel"
                    ? "company-row-henkel"
                    : company.name === "H.B. Fuller"
                    ? "company-row-hbfuller"
                    : company.name === "Bostik"
                    ? "company-row-bostik"
                    : company.name === "Tailored"
                    ? "company-row-tailored"
                    : "";

                return (
                  <tr key={idx} className={`company-row ${companyRowClass}`}>
                    <td className="px-4 fw-bold">{company.name}</td>
                    <td className="px-4">
                      {renderPositionDots(company.position, company.name)}
                    </td>
                    {detailModalView === "market_share" && (
                      <td className="px-4">{company.marketShare}</td>
                    )}
                    {detailModalView === "revenue" && (
                      <td className="px-4">{company.revenue}</td>
                    )}
                    {detailModalView === "focus" && (
                      <td className="px-4">{company.focus}</td>
                    )}
                    <td className="px-4 text-muted">{company.details}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className="p-4">
          <div className="takeaway-box">
            <div className="d-flex gap-3 align-items-start">
              <span style={{ fontSize: "1rem" }}>💡</span>
              <div className="flex-grow-1">
                <div
                  className="fw-bold mb-2"
                  style={{ fontSize: "14px", color: "#1e293b" }}
                >
                  Key Takeaways
                </div>
                <p
                  className="mb-0"
                  style={{
                    lineHeight: "1.6",
                    color: "#475569",
                    fontSize: "13px",
                  }}
                >
                  {modalData.keyTakeaways}
                </p>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DetailModal;